// extracted by css-extract-rspack-plugin
export default {"container":"TwoFactorAuthenticationSetup_container__+dABw"};